import {
  EmploymentType,
  JobListingType,
  PayUnit,
  PayUnitLabels,
} from 'src/graphql/types/jobListings'
import { Endorsement, LicenseClass } from 'src/graphql/types/licenses'

export interface JobListingAddress {
  street?: string | null
  city?: string | null
  state?: string | null
  country?: string | null
  zipCode?: string | null
}

export type JobListingFieldValue =
  | string
  | number
  | string[]
  | JobListingAddress
  | Date
  | null

export interface JobListingFormValues {
  title: string
  type: JobListingType | null
  address: JobListingAddress | null
  jobListingTemplateId: string | null
  subtitle: string
  description: string
  benefits: string[]
  employmentType: EmploymentType | null
  payMin: number | null
  payMax: number | null
  payUnit: PayUnit | null
  licenseClass: LicenseClass[]
  endorsements: Endorsement[]
  minMonthsExperience: number | null
  minEmploymentHistoryYears: number | null
}

interface JobListingFormSource {
  title?: string | null
  type?: JobListingType | null
  address?: JobListingAddress | null
  jobListingTemplate?: { jobListingTemplateId?: string | null } | null
  subtitle?: string | null
  description?: string | null
  benefits?: string[] | null
  employmentType?: EmploymentType | null
  payMin?: number | null
  payMax?: number | null
  payUnit?: PayUnit | null
  licenseClass?: LicenseClass[] | null
  endorsements?: Endorsement[] | null
  minMonthsExperience?: number | null
  minEmploymentHistoryYears?: number | null
}

export const buildJobListingFormValues = (
  job?: JobListingFormSource | null
): JobListingFormValues => ({
  title: job?.title ?? '',
  type: job?.type ?? null,
  address: job?.address ?? null,
  jobListingTemplateId: job?.jobListingTemplate?.jobListingTemplateId ?? null,
  subtitle: job?.subtitle ?? '',
  description: job?.description ?? '',
  benefits: job?.benefits ?? [],
  employmentType: job?.employmentType ?? null,
  payMin: job?.payMin ?? null,
  payMax: job?.payMax ?? null,
  payUnit: job?.payUnit ?? null,
  licenseClass: job?.licenseClass ?? [],
  endorsements: job?.endorsements ?? [],
  minMonthsExperience: job?.minMonthsExperience ?? null,
  minEmploymentHistoryYears: job?.minEmploymentHistoryYears ?? null,
})

export const parseNumberInput = (
  value: number | string | null | undefined
): number | null => (value === '' || value == null ? null : Number(value))

interface PayLike {
  payMin?: number | null
  payMax?: number | null
  payUnit?: PayUnit | null
}

export const formatPay = (pay: PayLike): string => {
  const hasMin = pay.payMin != null
  const hasMax = pay.payMax != null
  if (!hasMin && !hasMax) {
    return '-'
  }
  const min = hasMin ? `$${pay.payMin}` : ''
  const max = hasMax ? `$${pay.payMax}` : ''
  const range = min && max ? `${min}–${max}` : min || max
  const unit = pay.payUnit ? ` / ${PayUnitLabels[pay.payUnit]}` : ''
  return `${range}${unit}`
}
